<mat-divider></mat-divider>
<mat-toolbar class=footer-container>
  <div class="logo-container">
    <a mat-button [routerLink] = "'/'" class="button" color="primary" aria-label="Navigate to homepage">
      <app-logo-advanced></app-logo-advanced>
    </a>
  </div>

  <div class="mat-toolbar-container-text-small">
    <p>&copy; 2025 Sydney Advanced Endocrinology <br> All rights reserved &verbar; <a [routerLink]="'/sitemap'">Sitemap</a> <br> Made by <a href="https://dataalchemy.com.au/" aria-label="DataAlchemy">DataAlchemy</a> | <a href="#" role = "link" (click)="creditModal.open(); $event.preventDefault()" aria-label="View icon credits">Icon Credits</a></p>
  </div>
  <div class = "navbar-separator">
  </div>
</mat-toolbar>


<app-icon-credits-modal #creditModal></app-icon-credits-modal>
